import { Button } from "@/components/ui/button";
import { useFontStore } from "@/stores/useFontStore";
import { Check } from "lucide-react";
import { useEffect, useState } from "react";

export const FontSelector = () => {
  const { font, setFont } = useFontStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const fonts = [
    { name: 'poppins' as const, label: 'Poppins' },
    { name: 'inter' as const, label: 'Inter' },
    { name: 'roboto' as const, label: 'Roboto' },
    { name: 'opensans' as const, label: 'Open Sans' },
  ];

  // Prevent hydration mismatch
  if (!mounted) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {fonts.map(({ name, label }) => (
        <Button
          key={name}
          variant={font === name ? "default" : "outline"}
          className="justify-between w-full"
          onClick={() => setFont(name)}
        >
          <span className={`font-${name}`}>{label}</span>
          {font === name && <Check className="h-4 w-4 ml-2" />}
        </Button>
      ))}
    </div>
  );
};